import * as React from "react";
import type { SVGProps } from "react";
const SvgDriveSiteTraffic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={64}
    fill="none"
    {...props}
  >
    <path fill="#D3ECF8" d="M64.307 46.37H1.456v7.31h62.851v-7.31Z" />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M.456 46.37a1 1 0 0 1 1-1h62.851a1 1 0 0 1 1 1v7.31a1 1 0 0 1-1 1H1.456a1 1 0 0 1-1-1v-7.31Zm2 1v5.31h60.851v-5.31H2.456Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M2.456 9.283v43.52h61.088V9.283H2.456Zm-2-.53c0-.812.658-1.47 1.47-1.47h62.148c.812 0 1.47.658 1.47 1.47v44.58a1.47 1.47 0 0 1-1.47 1.47H1.926a1.47 1.47 0 0 1-1.47-1.47V8.753Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M25.157 19.424a2.183 2.183 0 1 0 0 4.366 2.183 2.183 0 0 0 0-4.366Zm-4.182 2.183a4.183 4.183 0 1 1 8.365 0 4.183 4.183 0 0 1-8.365 0ZM10.065 34.166a2.183 2.183 0 1 0 0 4.365 2.183 2.183 0 0 0 0-4.365Zm-4.183 2.182a4.183 4.183 0 1 1 8.365 0 4.183 4.183 0 0 1-8.365 0ZM40.966 32.16c-.603 0-1.15.246-1.546.642-.4.4-.642.942-.642 1.545a2.183 2.183 0 1 0 4.365 0V34.2a2.183 2.183 0 0 0-2.177-2.04Zm-2.96-.773a4.181 4.181 0 0 1 7.142 2.955v.414l-.027.027a4.183 4.183 0 1 1-7.115-3.396ZM64.649 47.508H1.19v-2H64.65v2Z"
      clipRule="evenodd"
    />
    <path fill="#D3ECF8" d="M52.355 15.921h7.132v7.072l-7.132-7.072Z" />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M51.43 15.54a1 1 0 0 1 .925-.619h7.132a1 1 0 0 1 1 1v7.072a1 1 0 0 1-1.704.71l-7.132-7.072a1 1 0 0 1-.22-1.09Zm3.354 1.381 3.703 3.672v-3.672h-3.703Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m42.625 31.265 12.854-12.38 1.387 1.44-12.854 12.38-1.387-1.44ZM38.109 32.894 26.8 24.414l1.2-1.6 11.308 8.48-1.2 1.6ZM11.49 33.272l10.497-10.14 1.39 1.438L12.88 34.71l-1.39-1.438Z"
      clipRule="evenodd"
    />
    <path fill="#D3ECF8" d="M38.581 53.685H27.26v6.014H38.58v-6.014Z" />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M26.26 53.685a1 1 0 0 1 1-1H38.58a1 1 0 0 1 1 1v6.014a1 1 0 0 1-1 1H27.26a1 1 0 0 1-1-1v-6.014Zm2 1v4.014h9.321v-4.014H28.26Z"
      clipRule="evenodd"
    />
    <path fill="#D3ECF8" d="M50.843 59.817H14.994V63h35.849v-3.183Z" />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M13.994 59.817a1 1 0 0 1 1-1h35.849a1 1 0 0 1 1 1V63a1 1 0 0 1-1 1H14.994a1 1 0 0 1-1-1v-3.183Zm2 1V62h33.849v-1.183H15.994Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDriveSiteTraffic;
